'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import type { ReactNode } from 'react';

import { ENV } from '@/services/config/env-config';

export const DatadogProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    if (
      datadogRum.getInitConfiguration() ||
      !ENV.DD_RUM_APPLICATION_ID ||
      !ENV.DD_RUM_CLIENT_TOKEN
    ) {
      return;
    }

    datadogRum.init({
      applicationId: ENV.DD_RUM_APPLICATION_ID,
      clientToken: ENV.DD_RUM_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: 'digiproc-customer',
      env: ENV.ENVIRONMENT || 'production',
      version: ENV.BUILD_COMMIT_SHA || '0.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      allowedTracingUrls: [
        { match: ENV.API_URL, propagatorTypes: ['datadog', 'tracecontext'] },
      ],
      traceSampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
    });
  }, []);

  return <>{children}</>;
};
